import React from 'react' 
import ReactLoading from 'react-loading';
import { ClipLoader } from "react-spinners";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { COLORS } from '../Constants';

const override = {
  display: "block",
  margin: "0 auto",
  borderColor: "white",
  fontWeight:'bold'
};


const Btncom = ({onKeyDown,title,icon,onClick,width,bgcolor,color,loading,margin,classname,padding,border,radius,bordercolor,fontsize}) => {

  
  return (
    <div>
      <button  disabled={loading} onKeyDown={onKeyDown} onClick={onClick}   variant="brand" className="cursor-pointer w-full bg-[#551cd1] hover:bg-[#8046fe] text-white my-2 font-semibold py-3 rounded-xl transition" >
      {icon && <FontAwesomeIcon style={{fontWeight:'bold',marginRight:8}} icon={icon} className="rainbow-m-left_medium" /> }
              { !loading && title}
            {loading && <ClipLoader size={20}  cssOverride={override} color='white' aria-label="Loading Spinner"
        data-testid="loader" />}
        </button>

        

        
    </div>
  )
}

export default Btncom